
export default {
    props: {
        // Absolute epoch ms at which the hold expires.
        expiresAtMs: { type: Number, default: null },
    },
    data () {
        return { now: Date.now(), tick: null }
    },
    computed: {
        msLeft () { return Math.max(0, (this.expiresAtMs || 0) - this.now) },
        mins () { return Math.floor(this.msLeft / 60000) },
        secs () { return String(Math.floor((this.msLeft % 60000) / 1000)).padStart(2, '0') },
    },
    mounted () {
        this.tick = setInterval(() => {
            this.now = Date.now()
            if (this.msLeft <= 0) {
                this.$emit('expired')
                clearInterval(this.tick)
            }
        }, 1000)
    },
    beforeDestroy () {
        if (this.tick) clearInterval(this.tick)
    },
}
